const cards = [
  {
    title: '韩漫下载安装全攻略',
    desc: '从零开始，手把手教你如何下载安装韩漫APP，支持安卓与iOS双平台详细教程。',
    tag: '新手必看',
    img: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20with%20Korean%20webtoon%20app%20interface%20on%20screen%2C%20clean%20white%20desk%20setting%2C%20soft%20natural%20light%2C%20minimal%20composition%2C%20warm%20coral%20accent%20details%2C%20product%20photography%20style%2C%20simple%20background&width=800&height=600&seq=card-01&orientation=landscape',
  },
  {
    title: '2026热门韩漫推荐榜单',
    desc: '年度最受欢迎韩漫TOP50大盘点，恋爱、奇幻、悬疑分类推荐，追漫不迷路。',
    tag: '榜单推荐',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20flat%20lay%20of%20illustrated%20comic%20book%20covers%20with%20Korean%20manhwa%20style%20art%2C%20warm%20cream%20background%2C%20soft%20shadows%2C%20editorial%20arrangement%2C%20clean%20aesthetic%2C%20coral%20and%20beige%20tones&width=800&height=600&seq=card-02&orientation=landscape',
  },
  {
    title: '离线韩漫阅读体验评测',
    desc: '对比主流韩漫APP离线功能，从画质、加载速度到存储空间，帮你选出最佳阅读工具。',
    tag: '深度评测',
    img: 'https://readdy.ai/api/search-image?query=A%20tablet%20displaying%20colorful%20comic%20pages%20in%20offline%20mode%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20Korean%20manhwa%20art%20style%20visible%2C%20relaxed%20atmosphere%2C%20cream%20and%20coral%20aesthetic&width=800&height=600&seq=card-03&orientation=landscape',
  },
  {
    title: '韩漫APK安全下载指南',
    desc: '如何识别安全的韩漫APK下载源，避免恶意软件和广告插件，保障手机安全。',
    tag: '安全指南',
    img: 'https://readdy.ai/api/search-image?query=A%20shield%20icon%20with%20smartphone%20showing%20secure%20download%20concept%2C%20clean%20minimal%20tech%20illustration%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20soft%20gradient%20background%2C%20modern%20flat%20design&width=800&height=600&seq=card-04&orientation=landscape',
  },
  {
    title: '韩漫汉化进度追踪',
    desc: '实时追踪最新韩漫汉化进度，热门作品翻译更新时间表一目了然。',
    tag: '追更必备',
    img: 'https://readdy.ai/api/search-image?query=A%20timeline%20or%20calendar%20style%20design%20with%20Korean%20comic%20illustration%20elements%2C%20organized%20schedule%20layout%2C%20warm%20beige%20and%20coral%20palette%2C%20clean%20editorial%20design%2C%20soft%20lighting&width=800&height=600&seq=card-05&orientation=landscape',
  },
  {
    title: '免费韩漫资源汇总',
    desc: '整理全网免费韩漫阅读渠道，包括官方正版与民间汉化组资源链接。',
    tag: '资源合集',
    img: 'https://readdy.ai/api/search-image?query=A%20collection%20of%20colorful%20Korean%20manhwa%20style%20illustrations%20arranged%20in%20a%20grid%2C%20warm%20cream%20background%2C%20soft%20shadows%2C%20editorial%20layout%2C%20coral%20accent%20highlights%2C%20clean%20composition&width=800&height=600&seq=card-06&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精选内容
          </h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            为韩漫爱好者精心策划的实用指南与深度内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card) => (
            <article
              key={card.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  title={`韩漫之家 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium">
                  {card.tag}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}